import React, { useState, useCallback, useContext, useEffect } from "react";

//Style
import { makeStyles } from "@material-ui/core/styles";

//Component
//--> Drawer
import SideDrawer from "../../components/Drawer/SideDrawer";
//--> Cover Image
import Cover from "../../components/Cover/Cover";
//--> Alert
import { Error, Success } from "../../components/Alert/Alert";
//--> Forms
import Forms from "../../components/Forms/Forms";
//--> Drag and Drop
import DragNDrop from "../../components/DND/DragNDrop";
//--> Title
import Title from "../../components/Title";
//--> Tables
import Tables from "../../components/Table/Tables";

//Context
import { AgentContext, AgentActionContext } from "../../context/AgentContext";

//MUI Style
const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
}));

export default function Agents() {
  //.. MUI Style Initiate
  const classes = useStyles();

  //Context
  const { agents, team } = useContext(AgentContext);
  const {
    setUpRecaptcha,
    registerAgent,
    readFile,
    demoAgentFile,
    removeAgent,
  } = useContext(AgentActionContext);

  //Recaptcha
  useEffect(() => {
    setUpRecaptcha();
  }, [setUpRecaptcha]);

  //States
  //--> Forms
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  //--> Alert
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  //--> Excel File
  const [file, setFile] = useState("");

  const TextBoxes = [
    {
      label: "Full Name",
      onChange: setFullName,
      value: fullName,
    },
    {
      label: "Phone Number",
      onChange: setPhoneNumber,
      value: phoneNumber,
      type: "phone",
    },
    {
      label: "Email",
      onChange: setEmail,
      value: email,
    },
    {
      label: "Address",
      onChange: setAddress,
      value: address,
      multiline: true,
    },
  ];

  const Excelheader = [
    "Avatar",
    "Name",
    "Email",
    "Phone Number",
    "Address",
    "Register Agent",
    "Dismiss",
  ];

  const Teamheader = ["Avatar", "Name", "Email", "Phone Number", "Address"];

  //--> Excel Work Start
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
    // Do something with the files
  }, []);

  const handleExcel = () => {
    readFile(file, setErr);
    setTimeout(() => {
      setFile("");
    }, 3000);
  };
  //--> Excel Work End

  //--> Regester Agent Work Start
  const handleAgentSubmit = () => {
    if (fullName && phoneNumber && email && address) {
      registerAgent(
        fullName,
        phoneNumber,
        email,
        address,
        setAlertTitle,
        setErr,
        setSuccess,
      );
      setTimeout(() => {
        setFullName("");
        setPhoneNumber("");
        setEmail("");
        setAddress("");
      }, 2000);
    } else {
      setErr("Please fill in all input box with required information!");
      setTimeout(() => {
        setErr("");
      }, 10000);
    }
  };

  const handleTableSubmit = (name, phoneNo, email, address) => {
    registerAgent(
      name,
      phoneNo,
      email,
      address,
      setAlertTitle,
      setErr,
      setSuccess,
    );
    setTimeout(() => {
      removeAgent(phoneNo);
    }, 2000);
  };
  //--> Regester Agent Work End

  //--> Handle Alert Start
  const Alert = err ? Error : success ? Success : null;
  const alert = err ? err : success ? success : null;
  //--> Handle Alert End

  return (
    <div style={{ display: "flex" }}>
      <SideDrawer />
      <div style={{ flex: 1 }}>
        <div className={classes.toolbar} />
        <Cover title="Agents Details" />
        <div className={classes.content}>
          <div id="recaptcha-container"></div>
          {alert !== null ? (
            <Alert
              title={alertTitle}
              msg={alert}
              style={{ margin: "0px 30px" }}
            />
          ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexFlow: "wrap-reverse",
              justifyContent: "center",
            }}
          >
            <DragNDrop
              onDrop={onDrop}
              file={file}
              handleSubmit={handleExcel}
              downloadFile={demoAgentFile}
            />
            <Forms
              label="Agents Entry Form:"
              TextBoxes={TextBoxes}
              onSubmit={handleAgentSubmit}
            />
          </div>

          <div style={{ margin: "0px 30px" }}>
            <Tables
              rows={agents}
              headers={Excelheader}
              submitLabel="Add Agent"
              handleSubmit={handleTableSubmit}
              handleDelete={removeAgent}
            />
            <Title title="Our Agents" overlay="Team" />
            <Tables rows={team} headers={Teamheader} submitLabel="Add Agent" />
          </div>
        </div>
      </div>
    </div>
  );
}
